import { render, staticRenderFns } from "./ReportingProfiles.vue?vue&type=template&id=32a28ab7&scoped=true&"
import script from "./ReportingProfiles.vue?vue&type=script&lang=js&"
export * from "./ReportingProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a28ab7",
  null
  
)

export default component.exports